// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2mtB-","textarea":"styles_textarea__39_DT"};